import { Component, Input } from '@angular/core';

/**
 * The app's spinner, on its own so anything can show it: the page loader paints it over the whole
 * screen, a dialog or a card drops it wherever it needs one.
 *
 * The host is `position: relative` because the twelve blades are absolutely positioned inside it;
 * a caller that needs it somewhere else positions the host, it does not move itself.
 */
@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: true,
    host: {
      'role': 'status',
      '[attr.aria-label]': 'label'
    }
})
export class SpinnerComponent {
  /** what a screen reader announces while it spins */
  @Input() label = 'Cargando';
}
